import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { SxProps, Theme } from '@mui/material/styles';

interface CopyrightProps {
  sx?: SxProps<Theme>;
}

export default function Copyright({ sx }: CopyrightProps) {
  return (
    <Typography variant='body2' color='text.secondary' align='center' sx={sx}>
      {'Copyright © '}
      <Link color='inherit' href='https://teapotchef.com/'>
        teapotchef.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
